"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upgradeExternalMeal = exports.upgradeUserProfile = exports.upgradeMeal = exports.MealSource = void 0;
// Shared enums and interfaces
var MealSource;
(function (MealSource) {
    MealSource["Wolt"] = "wolt";
})(MealSource = exports.MealSource || (exports.MealSource = {}));
// Upgrade Functions
function upgradeMeal(meal) {
    if (meal.v === undefined)
        meal.v = 1;
    switch (meal.v) {
        case 1:
            return Object.assign(Object.assign({}, meal), { v: 2, ingredients: meal.ingredients.map((ingredient) => (Object.assign(Object.assign({}, ingredient), { unit: ingredient.quantity, amount: 1 }))) });
        case 2:
            return meal;
        default:
            throw new Error(`Unknown Meal version: ${meal.v}`);
    }
}
exports.upgradeMeal = upgradeMeal;
function upgradeUserProfile(profile) {
    if (profile.v === undefined)
        profile.v = 1;
    switch (profile.v) {
        case 1:
            return profile;
        default:
            throw new Error(`Unknown UserProfile version: ${profile.v}`);
    }
}
exports.upgradeUserProfile = upgradeUserProfile;
function upgradeExternalMeal(meal) {
    if (meal.v === undefined)
        meal.v = 1;
    switch (meal.v) {
        case 1:
            return meal;
        default:
            throw new Error(`Unknown ExternalMeal version: ${meal.v}`);
    }
}
exports.upgradeExternalMeal = upgradeExternalMeal;
